const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Assessment grader instructions Component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('graderInstructions', [function () {
  return {
    restrict: 'E',
    scope: {
      question: '=',
      instructions: '=',
      hideInstructions: '@'
    },
    template: require('../../../templates/directives/assessments/grader-instructions.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.translations = {};
      self.froalaOverrides = {
        toolbarButtons: ['bold', 'italic', 'underline', 'color', 'emoticons', 'align', 'formatOL', 'formatUL', 'insertLink', 'undo', 'redo'],
        pasteAllowedStyleProps: ['font-family', 'font-weight', 'color'],
        pasteDeniedAttrs: ['src','onClick'],
        fontSizeDefaultSelection: '14'
      };

      self.info = {
        setOption: function(type, value) {
          if (!$scope.question) {
            return null;
          }
          if (!$scope.question.question_options) {
            $scope.question.question_options = [];
          }
          for (var i = 0; i < $scope.question.question_options.length; i++) {
            if ($scope.question.question_options[i] && $scope.question.question_options[i].name === type) {
              $scope.question.question_options[i].value = value;
              return;
            }
          }
          $scope.question.question_options.push({name: type, value: value});
        },
        getOption: function(type) {
          if (!$scope.question) {
            return null;
          }
          if (!$scope.question.question_options) {
            $scope.question.question_options = [];
            return null;
          }
          for (var i = 0; i < $scope.question.question_options.length; i++) {
            if ($scope.question.question_options[i] && $scope.question.question_options[i].name === type) {
              return $scope.question.question_options[i].value;
            }
          }
        },
        graderInstructions: '',
        graderInstructionsChange: function() {
          if (self.info.getOption('grader_instructions') !== self.info.graderInstructions) {
            self.info.graderInstructionsUpdate('grader_instructions');
          }
        },
        graderInstructionsUpdate: function() {
          self.info.setOption('grader_instructions', self.info.graderInstructions);
        }
      };

      $scope.$watch('grading.info.graderInstructions', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          self.info.graderInstructionsChange();
        }
      });

      if ($scope.question) {
        self.info.graderInstructions = self.info.getOption('grader_instructions') || false;
        return;
      }

      var graderQuestionWatch = $scope.$watch('question', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.info.graderInstructions = self.info.getOption('grader_instructions') || false;
          graderQuestionWatch();
        }
      });

    }],
    controllerAs: 'grading'
  };
}]);